import React, { Component } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import { EditorState, ContentState, convertToRaw } from 'draft-js';
import { convertFromHTML } from 'draft-js';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';

export default class TextEditor extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editorState: EditorState.createEmpty(),
      showToolbar: false, // Kezdetben az eszköztár rejtve van
    };
    this.debounceTimeout = null; // Késleltetéshez használt timeout
  }

  componentDidMount() {
    // Ha a szülő komponens átadott egy HTML-t, akkor azt betöltjük
    if (this.props.initialHtml) {
      this.loadHtmlContent(this.props.initialHtml);
    }
  }

  componentDidUpdate(prevProps) {
    // Amikor a szülő komponens új HTML-t ad át, betöltjük azt
    if (prevProps.initialHtml !== this.props.initialHtml) {
      this.loadHtmlContent(this.props.initialHtml);
    }
  }

  // HTML betöltése és átalakítása draft-js formátumba
  loadHtmlContent = (html) => {
    const blocksFromHTML = convertFromHTML(html);
    const contentState = ContentState.createFromBlockArray(
      blocksFromHTML.contentBlocks,
      blocksFromHTML.entityMap
    );
    const editorState = EditorState.createWithContent(contentState);
    this.setState({ editorState });
  };

  // A szerkesztő állapotának frissítése
  onEditorStateChange = (editorState) => {
    this.setState({ editorState });

    // Késleltetett változáskezelés a szülő komponens felé
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }

    // 500ms késleltetés, mielőtt a változást visszaküldjük a szülő komponensnek
    this.debounceTimeout = setTimeout(() => {
      const htmlContent = draftToHtml(
        convertToRaw(editorState.getCurrentContent())
      );
      this.props.onChange(htmlContent); // Visszaküldjük a módosított HTML-t a szülőnek
    }, 500);
  };

  // Fókusz esemény kezelése
  render() {
    const { editorState } = this.state;

    return (
      <div>
        <Editor
          editorKey={`${this.props?.column?.columnName?this.props?.column?.columnName:'test'}-editor`}
          editorState={editorState}
          toolbarClassName="toolbarClassName"
          wrapperClassName="wrapperClassName"
          editorClassName="editorClassName"
          onEditorStateChange={this.onEditorStateChange}
          toolbar={{
            options: ['inline', 'list', 'textAlign', 'link'],
            inline: {
              options: ['bold', 'italic', 'underline', 'strikethrough'], // Félkövér, Dőlt, Aláhúzás, Áthúzás
            },
            list: {
              options: ['unordered', 'ordered'], // Rendezett és rendezetlen lista
            },
            textAlign: {
              options: ['left', 'center', 'right', 'justify'], // Szöveg igazítása
            },
            link: {
              options: ['link', 'unlink'], // Link és link eltávolítása
              inDropdown: false,
              defaultTargetOption: '_blank',
              showOpenOptionOnHover: true,
              dropdownClassName: undefined,
            },
            /*  history: {
              options: ['undo', 'redo'], // Oda-vissza lépegetés
            },*/
          }}
        />
        {/*  <textarea
          disabled
          value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
        ></textarea>*/}
      </div>
    );
  }
}
